import {ThemeColorName, ThemeType} from '../../../theme/types';

const colorNameExictedMap: {
  [key in ThemeColorName]?: ThemeColorName;
} = {
  background_mono_primary: 'background_mono_excited',
  background_mono_secondary: 'background_mono_excited',
  background_mono_tertiary: 'background_mono_excited',
  background_mono_excited: undefined,

  background_mono_inverse_primary: 'background_mono_inverse_excited',
  background_mono_inverse_excited: undefined,
  background_mono_inverse_disabled: undefined,

  background_overlay_dark: undefined,

  background_accent_default: 'background_accent_excited',
  background_accent_excited: undefined,
  background_accent_disabled: undefined,
  background_accent_light: 'background_accent_excited',

  background_positive_default: 'background_positive_excited',
  background_positive_excited: undefined,
  background_positive_disabled: undefined,
  background_positive_light: 'background_positive_excited',

  background_warning_default: 'background_warning_excited',
  background_warning_excited: undefined,
  background_warning_disabled: undefined,
  background_warning_light: 'background_warning_excited',

  background_negative_default: 'background_negative_excited',
  background_negative_excited: undefined,
  background_negative_disabled: undefined,
  background_negative_light: 'background_negative_excited',

  border_mono_10: 'border_mono_10',
  border_mono_15: 'border_mono_15',
  border_mono_30: 'border_mono_30',

  border_mono_inverse_10: 'border_mono_inverse_10',
  border_mono_inverse_15: 'border_mono_inverse_15',
  border_mono_inverse_30: 'border_mono_inverse_30',

  border_accent_default: 'border_accent_excited',
  border_accent_excited: undefined,
  border_accent_disabled: undefined,

  border_positive_default: 'border_positive_excited',
  border_positive_excited: undefined,
  border_positive_disabled: undefined,

  border_warning_default: 'border_warning_excited',
  border_warning_excited: undefined,
  border_warning_disabled: undefined,

  border_negative_default: 'border_negative_excited',
  border_negative_excited: undefined,
  border_negative_disabled: undefined,

  content_mono_primary: 'content_mono_primary',
  content_mono_secondary: 'content_mono_secondary',
  content_mono_disabled: 'content_mono_disabled',

  content_mono_inverse_primary: 'content_mono_inverse_primary',
  content_mono_inverse_secondary: 'content_mono_inverse_secondary',
  content_mono_inverse_disabled: 'content_mono_inverse_disabled',

  content_accent_default: 'content_accent_excited',
  content_accent_excited: undefined,
  content_accent_disabled: undefined,

  content_positive_default: 'content_positive_excited',
  content_positive_excited: undefined,
  content_positive_disabled: undefined,

  content_warning_default: 'content_warning_excited',
  content_warning_excited: undefined,
  content_warning_disabled: undefined,

  content_negative_default: 'content_negative_excited',
  content_negative_excited: undefined,
  content_negative_disabled: undefined,

  transparent: 'background_mono_excited',
};

export const getExcitedColor = (
  theme: ThemeType,
  color?: ThemeColorName,
): string | undefined => {
  if (!color) return undefined;
  const excitedColorName = colorNameExictedMap[color];
  return excitedColorName ? theme.colors[excitedColorName] : undefined;
};
